import React, { useId } from "react";
import { useLanguage } from "../i18n";

/**
 * Inline SVG flag icons — no external dependencies needed.
 * Simplified but recognizable UK & Italian flags.
 */
function FlagEN() {
  const id = useId();
  const clipS = `${id}-s`;
  const clipT = `${id}-t`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 30"
      width="28"
      height="14"
      className="lang-flag"
      aria-hidden="true"
    >
      {/* Union Jack simplified */}
      <clipPath id={clipS}><path d="M0,0 v30 h60 v-30 z"/></clipPath>
      <clipPath id={clipT}><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"/></clipPath>
      <g clipPath={`url(#${clipS})`}>
        <path d="M0,0 v30 h60 v-30 z" fill="#012169"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath={`url(#${clipT})`} stroke="#C8102E" strokeWidth="4"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
      </g>
    </svg>
  );
}

function FlagIT() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 3 2"
      width="28"
      height="18"
      className="lang-flag"
      aria-hidden="true"
    >
      <rect width="1" height="2" x="0" fill="#009246" />
      <rect width="1" height="2" x="1" fill="#fff" />
      <rect width="1" height="2" x="2" fill="#CE2B37" />
    </svg>
  );
}

export default function LanguageSwitcher() {
  const { language, switchLanguage } = useLanguage();

  return (
    <div className="language-switcher" role="group" aria-label="Language selector">
      <button
        type="button"
        className={`lang-btn ${language === "en" ? "lang-active" : ""}`}
        onClick={() => switchLanguage("en")}
        aria-label="English"
        title="English"
      >
        <FlagEN />
        <span className="lang-label">EN</span>
      </button>
      <button
        type="button"
        className={`lang-btn ${language === "it" ? "lang-active" : ""}`}
        onClick={() => switchLanguage("it")}
        aria-label="Italiano"
        title="Italiano"
      >
        <FlagIT />
        <span className="lang-label">IT</span>
      </button>
    </div>
  );
}
